import { render } from "./GoodsThick.vue?vue&type=template&id=a52bc578&scoped=true"
import script from "./GoodsThick.vue?vue&type=script&lang=js"
export * from "./GoodsThick.vue?vue&type=script&lang=js"

import "./GoodsThick.vue?vue&type=style&index=0&id=a52bc578&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52bc578"]])

export default __exports__